import { useState } from 'react';

export default function Navbar(){
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    
      const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
      };
    return (
        <div className="text-white ">
        {/* Navigation Bar */}
      <nav className="fixed w-full bg-black z-10 shadow-sm border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              {/* <div className="text-xl font-bold">Jonathan Doe</div> */}
              <h1 className="text-3xl font-extrabold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 drop-shadow-lg">
                Filmy Quiz App
              </h1>
            </div>
            
            {/* Mobile menu button */}
            <div className="flex items-center sm:hidden">
              <button 
                onClick={toggleMenu}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-900 hover:text-gray-600 focus:outline-none"
              >
                <svg 
                  className="h-6 w-6" 
                  xmlns="http://www.w3.org/2000/svg" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor"
                >
                  {isMenuOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  )}
                </svg>
              </button>
            </div>
            
            {/* Desktop navigation links */}
            <div className="hidden sm:flex sm:items-center">
              <div className="ml-10 flex items-baseline space-x-4">
                <a href="/" className="px-3 py-2 text-sm font-medium hover:text-purple-600">Home</a>
                <a href="#about" className="px-3 py-2 text-sm font-medium hover:text-purple-600">About</a>
                <a href="#projects" className="px-3 py-2 text-sm font-medium hover:text-purple-600">Projects</a>
                <a href="#contact" className="px-3 py-2 text-sm font-medium hover:text-purple-600">Contact</a>
                <a 
                  href="https://play.google.com/store/apps/details?id=com.perutions.cqz&pcampaignid=web_share" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ml-4 px-4 py-2 text-sm font-medium text-white bg-[#5e0a57] rounded-md hover:bg-[#2b0528]"
                >
                  Download App
                </a>
              </div>
            </div>
          </div>
        </div>
        
        {/* Mobile menu */}
        <div className={`sm:hidden ${isMenuOpen ? 'block' : 'hidden'}`}>
          <div className="px-2 pt-2 pb-3 space-y-1">
            <a 
              href="#hero" 
              className="block px-3 py-2 text-base font-medium hover:text-purple-600"
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </a>
            <a 
              href="#about" 
              className="block px-3 py-2 text-base font-medium hover:text-purple-600"
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </a>
            <a 
              href="#projects" 
              className="block px-3 py-2 text-base font-medium hover:text-purple-600"
              onClick={() => setIsMenuOpen(false)}
            >
              Projects
            </a>
            <a 
              href="#contact" 
              className="block px-3 py-2 text-base font-medium hover:text-purple-600"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </a>
            <a 
              href="https://play.google.com/store/apps/details?id=com.perutions.cqz&pcampaignid=web_share" 
              target="_blank"
              rel="noopener noreferrer"
              className="block px-3 py-2 mt-4 text-center text-white bg-[#5e0a57] rounded-md hover:bg-[#2b0528]"
              onClick={() => setIsMenuOpen(false)}
            >
              Download App
            </a>
          </div>
        </div>
      </nav>
      </div>
    );
}